module.exports = __webpack_public_path__ + "img/red54.7bd42bc7.svg";